var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVegan = function SvgVegan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vegan"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path347",
    d: "M1 5.97886C5.28591 8.46745 6.45496 17 6.45496 17C6.45496 17 8.01431 6.33474 14.6383 3.1344M8.93516 9.3197C7.33613 7.48312 7.44132 4.85824 9.18336 3.13356C11.1312 1 16.9764 1 16.9764 1C16.9764 1 17.316 4.83973 15.418 7.39983C13.7073 9.70586 11.1367 10.5539 8.93516 9.3197Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeMiterlimit: 34.043,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgVegan;